/**
 * 시즌 태그 (🌸 매해 / ✨ 단발) 간략 설명 — 4 stage 탭 박스 옆 공통 legend.
 *
 * 베타 사용자가 카드에 처음 보이는 시즌 칩 의미를 즉시 파악할 수 있도록.
 * 홈 LifecycleTabs + /trends 페이지 양쪽에 동일 노출 (사용자 결정 2026-05-20).
 *
 * 데이터 source = `KeywordRolling.seasonal_type` (마이그 087):
 *  - annual  : 3년 이상 같은 월 (±1) 반복 + peak/avg ≥ 1.8 (예: 수박주스 6-8월)
 *  - one_off : 최근 12개월 내 peak/total_avg ≥ 2.5 단발 폭발 (예: 두바이쫀득쿠키 2026-01)
 */
export function SeasonalTagLegend() {
  // 2026-05-21 (사용자 결정) — 모바일 2줄 wrap → 한 줄 압축. 칩 + 짧은 단어만.
  return (
    <div className="mb-3 px-1 flex items-center gap-2 text-2xs text-text-sub leading-snug">
      <span className="bg-rose-500/15 text-rose-400 font-bold rounded-full px-1.5 py-0.5 shrink-0">🌸 매해</span>
      <span>매해 반복</span>
      <span className="bg-amber-500/15 text-amber-400 font-bold rounded-full px-1.5 py-0.5 shrink-0">✨ 단발</span>
      <span>단발 폭발</span>
    </div>
  );
}
